import React, { useEffect, useState } from "react";
import { Modal, Alert, Row, Col, Card } from "react-bootstrap";
import Utils from "./../../common/Utils";
import _ from "lodash";
import axios from "axios";
import { JobEvidence } from "../Jobs";

const EvidenceList = (props) => {
  const edit = _.get(props, "data.edit", false);
  const userJob = _.get(props, "data.userJob", {});
  const [evidences, setEvidences] = useState(_.get(props, "data.evidences", []));
  const [refreshing, setRefreshing] = useState(false);

  const deleteEvidence = (fno) => (e) => {
    if (window.confirm("You are going to delete this evidence, continue?")) {
      setRefreshing(true);
      axios
        .post(Utils.apiUrl("jobs/evidenceDelete"), `ujid=${_.get(userJob, "id", 0)}&fno=${fno}`, Utils.apiHeaders())
        .then((res) => {
          setRefreshing(false);
          if (res.data.success) {
            setEvidences(res.data.evidences);
            if (!_.isUndefined(props.onEvidenceChange)) {
              props.onEvidenceChange(userJob.id);
            }
          } else {
            //window.alert(res.data.message);
          }
        })
        .catch((err) => {
          setRefreshing(false);
          console.log(err);
        });
    }
  };

  return (
    <Modal aria-labelledby="contained-modal-title-vcenter" size={edit ? "lg" : "sm"} centered show={true} onHide={props.onHide}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{edit ? "Edit" : "View"} Evidence</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {evidences.length === 0 && <Alert variant="danger">No Evidence found</Alert>}

        {evidences.map((res, fno) => (
          <Row key={res.id} className="my-3">
            <Col sm={10} className="text-truncate">
              {res}
            </Col>
            <Col sm={2} className="text-end">
              <a
                target="_blank"
                href={Utils.apiUrl(
                  `${props.type === "tasks" ? "tasks" : "jobs"}/downloadevidence?type=${props.type}&${props.type === "tasks" ? "tid" : "ujid"}=${
                    props.data.id
                  }&fno=${fno}`
                )}
              >
                {/* <a
                href={Utils.apiUrl(
                  `${props.type === "tasks" ? "tasks" : "jobs"}/downloadevidence?type=${props.type}&${props.type === "tasks" ? "tid" : "ujid"}=${
                    props.data.id
                  }&fno=${fno}`
                )}
              > */}
                <img src={`${process.env.PUBLIC_URL}/images/download.png`} border="0" />
              </a>
              {edit && evidences.length > 1 && (
                <img src={`${process.env.PUBLIC_URL}/images/delete.png`} className="ms-2 clickable" onClick={deleteEvidence(fno)} />
              )}
            </Col>
          </Row>
        ))}

        {edit && (
          <Card>
            <Card.Body>
              <JobEvidence edit={edit} userJob={userJob} userJobSubmit={props.userJobSubmit} onHide={props.onHide} />
            </Card.Body>
          </Card>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default EvidenceList;
